import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { fallbackCulture, getUserSettingsCulture } from '@capital-access/common/globalization';
import { BaseAsyncPipe } from '@capital-access/common/utils';
import { datePatternOptions } from '../formatting-options/date-pattern.options';
import { DateFormat } from '../models/date-formatting.models';

@Pipe({
  name: 'caDateFormat',
  pure: false,
  standalone: false
})
export class DateFormatPipe extends BaseAsyncPipe<string, DateFormat> implements PipeTransform {
  private userCulture$ = this.store.select(getUserSettingsCulture);

  constructor(private store: Store, changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  getTransformer(format: DateFormat): Observable<string> {
    return this.userCulture$.pipe(
      map(culture => {
        if (datePatternOptions[culture]) return datePatternOptions[culture][format];
        else return datePatternOptions[fallbackCulture][format];
      })
    );
  }
}
